import { useCallback, useMemo, useState } from "react";

export interface UseOpenableReturn {
	isOpen: boolean;
	open: () => void;
	close: () => void;
	toggle: () => void;
}

function useOpenable({ defaultOpen } = { defaultOpen: false }): UseOpenableReturn {
	const [isOpen, setIsOpen] = useState(defaultOpen);

	const open = useCallback(() => {
		setIsOpen(true);
	}, []);

	const close = useCallback(() => {
		setIsOpen(false);
	}, []);

	const toggle = useCallback(() => {
		setIsOpen((prev) => !prev);
	}, []);

	return useMemo(
		() => ({
			isOpen,
			open,
			close,
			toggle,
		}),
		[isOpen, open, close, toggle],
	);
}

export default useOpenable;
